import React from 'react';

import useShareData from '../../../hooks/useShareData';

import InputProducts from '../../../inputs/InputProducts';
import InputCheckboxCollection from '../../../inputs/InputCheckboxCollection';
import InputError from '../../../inputs/InputError';
import ButtonPrimary from '../../../components/ButtonPrimary';
import Loading from '../../../components/Loading';

import { termsAndConditionsOptions } from '../constants';

export default function Step3({
  className,
  values,
  errors,
  setValue,
  setDirty,
  nextStep,
  petTypes,
}) {
  const [ loading, error, products ] = useShareData();

  if(loading) return (
  <section className="share__step-3">
    <Loading />
  </section>
  )

  if(error) return (
  <section className="share__step-3">
    Error loading products. Please try again.
  </section>
  )

  if(!values.petType) return <section className={`share__step-3 pt20 ${ className || '' }`}>You must select a pet type above!</section>;

  return (
  <section className={`share__step-3 ${ className || '' }`}>
    <div className="mb24">
      <InputProducts
        className="mb40"
        name="products"
        value={values.products}
        products={products}
        setValue={setValue}
        petTypes={petTypes}
        currentPetType={values.petType}
      />
      <InputError
        className="mb24"
        hasError={errors.productsRequiredError  }
      >
        You must select at least one product.
      </InputError>
    </div>
    <div className="mb24">
      <InputCheckboxCollection
        className="w100%"
        name="termsAndConditions"
        value={values.termsAndConditions}
        setValue={setValue}
        setDirty={setDirty}
        checkboxOptions={termsAndConditionsOptions}
        disableAutoComplete={true}
        dangerouslyRenderLabels={true}
      />
      <InputError
        className="mb24"
        hasError={errors.termsAndConditionsRequiredError  }
      >
        You must accept the terms and conditions to continue.
      </InputError>
    </div>
    <div className="mb24 df jcfe">
      <ButtonPrimary onClick={nextStep}>
        Submit
      </ButtonPrimary>
    </div>
    <InputError
      className="tar mb24"
      hasError={
         errors.productsRequiredError
      || errors.termsAndConditionsRequiredError
      }
    >
      This part of the form has errors.
    </InputError>
  </section>
  );
}
